/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NotificationPreferenceCategoryListEntry } from './NotificationPreferenceCategoryListEntry';
import {
    NotificationPreferenceCategoryListEntryFromJSON,
    NotificationPreferenceCategoryListEntryFromJSONTyped,
    NotificationPreferenceCategoryListEntryToJSON,
} from './NotificationPreferenceCategoryListEntry';

/**
 * 
 * @export
 * @interface FindAllPreferences200Response
 */
export interface FindAllPreferences200Response {
    /**
     * 
     * @type {Array<NotificationPreferenceCategoryListEntry>}
     * @memberof FindAllPreferences200Response
     */
    data?: Array<NotificationPreferenceCategoryListEntry>;
}

/**
 * Check if a given object implements the FindAllPreferences200Response interface.
 */
export function instanceOfFindAllPreferences200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllPreferences200ResponseFromJSON(json: any): FindAllPreferences200Response {
    return FindAllPreferences200ResponseFromJSONTyped(json, false);
}

export function FindAllPreferences200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllPreferences200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(NotificationPreferenceCategoryListEntryFromJSON)),
    };
}

export function FindAllPreferences200ResponseToJSON(value?: FindAllPreferences200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(NotificationPreferenceCategoryListEntryToJSON)),
    };
}

